var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.currentActivityProduct && _vm.baseUnits)?_c('UnitSelection',{attrs:{"selectedUnitId":_vm.selectedUnitId,"units":_vm.baseUnits},on:{"update:unit":_vm.updateUnit}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }